const now = new Date();
const nextMonday = new Date(now);
nextMonday.setDate(now.getDate() + ((8 - now.getDay()) % 7 || 7));
nextMonday.setHours(12, 0, 0, 0);
const lastMonday = new Date(now);
lastMonday.setDate(now.getDate() - ((now.getDay() + 6) % 7));
lastMonday.setHours(12, 0, 0, 0);
const lastWednesday = new Date(now);
lastWednesday.setDate(now.getDate() - ((now.getDay() + 4) % 7));
lastWednesday.setHours(12, 0, 0, 0);

const orders = [
  {
    delivery_date: lastMonday.toISOString().substring(0, 23),
    accepted_date: lastMonday.toISOString().substring(0, 23),
    supl: 1,
    delivered_as_expected: true,
  },
  {
    delivery_date: lastWednesday.toISOString().substring(0, 23),
    accepted_date: lastWednesday.toISOString().substring(0, 23),
    supl: 2,
    delivered_as_expected: true,
  },
  {
    delivery_date: nextMonday.toISOString().substring(0, 23),
    accepted_date: null,
    supl: 1,
    delivered_as_expected: null,
  },
];
export function createExampleOrders(store: any) {
  const existing = store.peekAll('order');
  if (existing.length > 0) {
    return false;
  }
  const models = orders.map((order) => {
    return store.createRecord('order', {
      supplier: store.peekRecord('supplier', order.supl),
      delivery_date: new Date(order.delivery_date),
      accepted_date: order.accepted_date ? new Date(order.accepted_date) : null,
      delivered_as_expected: order.delivered_as_expected,
      company: store.peekRecord('company', 1),
      created_by: store.peekRecord('user', 1),
      accepted_by: order.accepted_date ? store.peekRecord('user', 1) : null,
    });
  });
  return Promise.all(models.map((model) => model.save()));
}
